const copyUSPIcons = () => {
    const selectors = {
        insertUspIconsContainer: "#uspIconsContainer",
        insertUspIconsContainerMobile: "#uspIconsContainerMobile",
        fetchUspIconsContainer: "[data-usp-icons-js]"
    }

    const insertContainer = document.querySelector(selectors.insertUspIconsContainer);
    const insertContainerMobile = document.querySelector(selectors.insertUspIconsContainerMobile);
    const fetchContainer = document.querySelector(selectors.fetchUspIconsContainer);


    const init = () => {
        const media = window.matchMedia("(max-width: 750px)");
        if (media.matches) {
            copyMobile();
            return;
        }

        copyDesktop();

    }
    const copyMobile = () => {
        if (!insertContainerMobile || !fetchContainer) return;
        insertContainerMobile.innerHTML = fetchContainer.innerHTML;
        const childCount = fetchContainer.children.length;

        if (childCount > 3) {
            insertContainerMobile.classList.add('scroll');
        }
        fetchContainer.remove();
    };


    const copyDesktop = () => {
        if (!insertContainer || !fetchContainer) return;

        insertContainer.innerHTML = fetchContainer.innerHTML;
        const scroll = fetchContainer.dataset.scroll;

        if (scroll) {
            insertContainer.classList.add('scroll');
        }

        fetchContainer.remove();
    }


    init();
}

window.addEventListener('DOMContentLoaded', (event) => {
    copyUSPIcons();

});